import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import {
  AnalyticsService,
  NgxBarGroup,
} from '../../services/api';

type MostWatchedByThemeRequest = {
  // chart controls
  metric?: 'total' | 'reached' | 'distinctUsers';
  topThemes?: number;
  maxVideosPerTheme?: number;

  // optional filters (omit for “all”)
  grade?: string; level?: string; theme?: string; tag?: string;
  publisher?: string; hasQuiz?: boolean; quizId?: string;
  datePublishedFromUtc?: string; datePublishedToUtc?: string;
};

@Component({
  selector: 'app-most-watched-by-theme',
  templateUrl: './most-watched-by-theme.component.html',
  styleUrls: ['./most-watched-by-theme.component.scss']
})
export class MostWatchedByThemeComponent implements OnInit, OnChanges {
  @Input() viewsize: [number, number] = [1000, 520];
  @Input() disableResize: boolean = false;
  // When true (dashboard tile), limit to top 5 themes for a concise preview
  @Input() tileMode: boolean = false;
  // Date range from parent dashboard
  @Input() startDate?: Date | null;
  @Input() endDate?: Date | null;
  showXAxis = true;
  showYAxis = true;
  showLegend = false;
  showXAxisLabel = true;
  showYAxisLabel = true;
  // For horizontal charts, x-axis is the value axis
  xAxisLabel = 'Views';
  yAxisLabel = 'Theme';

  chartData: NgxBarGroup[] = [];
  loading = false;
  errorMsg = '';

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit(): void {
    this.fetchReport();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['startDate'] || changes['endDate']) {
      this.fetchReport();
    }
  }

  private fetchReport(): void {
    this.loading = true;
    this.errorMsg = '';

    const body: MostWatchedByThemeRequest = {
      metric: 'total',
      topThemes: 10,
      maxVideosPerTheme: 6,
      datePublishedFromUtc: this.startDate ? this.startDate.toISOString() : undefined,
      datePublishedToUtc: this.endDate ? this.endDate.toISOString() : undefined
      // leave grade/level/theme/tag/publisher unset => include all
    };

    this.analyticsService.analyticsGetMostWatchedVideosByThemePost(body).subscribe({
        next: (data) => {
          const full = Array.isArray(data) ? data : [];
          this.chartData = this.tileMode ? full.slice(0, 5) : full;
          this.loading = false;
          // Force a one-time relayout for fixed-size tile on first paint
          if (this.disableResize) {
            setTimeout(() => {
              this.viewsize = [this.viewsize[0], this.viewsize[1]];
            });
          }
        },
        error: (err) => {
          console.error(err);
          this.errorMsg = 'Failed to load data.';
          this.loading = false;
        }
      });
  }

  // Formatters (optional niceties)
  formatTheme = (label: string) => {
    if (!label) return '';
  const max = 12; // more aggressive trim to avoid overlap in tiles
    return label.length > max ? label.slice(0, max - 1) + '…' : label;
  };

  formatCount = (val: any) => {
    const n = Number(val);
    return Number.isFinite(n) ? n.toLocaleString() : val;
  };

  onResize(event: any) {
  if (this.disableResize) return;
  const w = event?.target?.innerWidth ?? 1200;
  this.viewsize = [Math.max(720, Math.floor(w * 0.8)), 520];
  }
}
